
import Header from '@/components/General/Header.vue';
import { MUTATIONS } from '@/constants/mutationNames';
import { FLOW_NORMAL } from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { GETTERS } from '@/constants/getterNames';

@Component({
  components: {
    Header,
  },
})
export default class TicketsView extends Vue {

  public routes: RouteConfig[] = FLOW_NORMAL;

  get error() {
    return this.$store.getters[GETTERS.GET_ERROR];
  }

  public created() {
    /*
      Reset ticket selection since giftcard / normal tickets should not be in the same cart
     */
    this.$store.commit(MUTATIONS.RESET_TICKETS);
  }

  public dismissError() {
    this.$store.commit(MUTATIONS.SET_ERROR, {});
  }

}
